import AIP from './AIPContainer';

export default AIP;
